import { render, staticRenderFns } from "./BrokerItem.vue?vue&type=template&id=0cf8ef9a&scoped=true&"
import script from "./BrokerItem.vue?vue&type=script&lang=js&"
export * from "./BrokerItem.vue?vue&type=script&lang=js&"
import style0 from "./BrokerItem.vue?vue&type=style&index=0&id=0cf8ef9a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf8ef9a",
  null
  
)

export default component.exports